import React from 'react';
import loadable from '@loadable/component';
import type { Props } from './ux-lite-questions';

const UxLiteQuestionsLoadable = loadable(
  () => import(/* webpackChunkName: "ux-lite" */ './ux-lite-questions')
);

export const UxLiteQuestions = (props: Props) => (
  <UxLiteQuestionsLoadable {...props} />
);
